export { depRegToStringChecker } from './dep-reg-to-string.checker';
export { elementIdChecker } from './element-id.checker';
export { functionToStringChecker } from './function-to-string.checker';
export { regToStringChecker } from './reg-to-string.checker';
export { debuggerChecker } from './debugger.checker';



// WEBPACK FOOTER //
// ./src/checkers/checkers.ts